
import { Component, Vue } from "vue-property-decorator";
import { SMCases } from "@/store";
import {
  CANDIDATE_ASSESSMENT_SERVICE_TYPE,
  SKILLED_WORKER_COS_INSIDE_SERVICE_TYPE,
  SKILLED_WORKER_COS_SERVICE_TYPE,
  SKILLED_WORKER_SERVICE_TYPE,
  SKILLED_WORKER_INSIDE_SERVICE_TYPE,
  DEPENDANT_INSIDE_SERVICE_TYPE,
} from "@/constants/services";

@Component({
  components: {
    AssessmentHighlight: () => import("@/components/Widgets/Highlights/Assessment/Highlight.vue"),
    CosPlusSwHighlight: () => import("@/components/Widgets/Highlights/CoS+SW/Highlight.vue"),
    SwHighlight: () => import("@/components/Widgets/Highlights/SW/Highlight.vue"),
    DependantHighlight: () => import("@/components/Widgets/Highlights/Dependant/Highlight.vue"),
    PaidServicesHighlight: () =>
      import("@/components/Widgets/Highlights/PaidServices/Highlight.vue"),
  },
})
export default class HighlightCandidateOrEmployer extends Vue {
  // TODO: Move to "Vuex" computed variable to shared method;
  get isAssessment() {
    return SMCases.caseType === CANDIDATE_ASSESSMENT_SERVICE_TYPE;
  }

  get isCosPlusSw() {
    return [SKILLED_WORKER_COS_SERVICE_TYPE, SKILLED_WORKER_COS_INSIDE_SERVICE_TYPE].includes(
      SMCases.caseType
    );
  }

  get isSw() {
    return [SKILLED_WORKER_SERVICE_TYPE, SKILLED_WORKER_INSIDE_SERVICE_TYPE].includes(
      SMCases.caseType
    );
  }

  get isDependant() {
    return [DEPENDANT_INSIDE_SERVICE_TYPE].includes(SMCases.caseType);
  }
}
